import Vue from 'vue'

import AccountRepository from '@/repositories/AccountRepository'
import AccountRepositoryMock from '@/repositories/AccountRepositoryMock'
import AnnouncementRepository from '@/repositories/AnnouncementRepository'
import AnnouncementRepositoryMock from '@/repositories/AnnouncementRepositoryMock'
import CompanyRepository from '@/repositories/CompanyRepository'
import CompanyRepositoryMock from '@/repositories/CompanyRepositoryMock'
import FrogRepository from '@/repositories/FrogRepository'
import FrogRepositoryMock from '@/repositories/FrogRepositoryMock'

// 各コンポーネントからアクセスするときの名前登録（テンプレ）
Vue.mixin({
  beforeCreate() {
    const options = this.$options
    if (options.repositories) this.$repositories = options.repositories
    else if (options.parent && options.parent.$repositories)
      this.$repositories = options.parent.$repositories
  },
})

const masterRepositories = {
  account: AccountRepository,
  company: CompanyRepository,
}

const frogRepositories = {
  announcement: AnnouncementRepository,
  frog: FrogRepository,
}

const mockMasterRepositories = {
  account: AccountRepositoryMock,
  company: CompanyRepositoryMock,
}

const mockMouseRepositories = {
  announcement: AnnouncementRepositoryMock,
  frog: FrogRepositoryMock,
}

export default {
  get(name) {
    let repository

    if (process.env.VUE_APP_MASTER_API_URL_BASE) {
      repository = masterRepositories[name]
    } else {
      repository = mockMasterRepositories[name]
    }

    if (repository) {
      return repository
    }

    if (process.env.VUE_APP_QUERY_API_URL_BASE) {
      repository = frogRepositories[name]
    } else {
      repository = mockMouseRepositories[name]
    }

    if (repository) {
      return repository
    }

    throw new Error(`リポジトリ ${name} が見つかりませんでした`)
  },
}
